import { createSlice } from "@reduxjs/toolkit";
import {
  getAccess,
  readFromLocalStorage,
  saveToLocalStorage,
} from "utils/helper";

const { REACT_APP_API_KEY } = process.env;

const localData = readFromLocalStorage("currentUser")
  ? JSON.parse(readFromLocalStorage("currentUser"))
  : {};

const initialState = {
  data: localData,
  isAuthenticating: false,
  isAuthenticated: readFromLocalStorage("isAuthenticated") === "true",
  error: "",
  accessLevel: getAccess(localData?.data?.data?.userType || 0),
};

export const authSlice = createSlice({
  name: "authData",
  initialState,
  reducers: {
    authUserBegin: (state) => {
      state.isAuthenticating = true;
      state.isAuthenticated = false;
      state.data = initialState.data;
    },

    authUserSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.isAuthenticating = false;
      state.data = action.payload.data;
      const authData = action?.payload?.auth_key || null;
      saveToLocalStorage("currentUser", JSON.stringify(action.payload.data));
      saveToLocalStorage("isAuthenticated", "true");
      saveToLocalStorage("userAccessToken", authData || REACT_APP_API_KEY);
      //state.accessLevel = getAccess(authData?.data?.userType || 0);
    },

    authUserError: (state, action) => {
      state.isAuthenticated = false;
      state.isAuthenticating = false;
      state.error = action.payload;
    },

    authUserAccess: (state, action) => {
      const user_access = state.data.data.userType;
      state.accessLevel = user_access === 90 ? 2 : action.payload;
    },

    resetState: (state) => {
      return initialState;
    },
  },
});

export const { authUserBegin, authUserSuccess, authUserError, authUserAccess } =
  authSlice.actions;

export const authDataSelector = (state) => state.authData.data;

export default authSlice.reducer;
